<h2 mat-dialog-title>Eine Messstelle exportieren</h2>

<mat-dialog-content class="dialog-content">

  <p class="intro">
    Ein vollständiges IBN-Protokoll für eine einzelne Messstelle –
    mit allen Prüfpunkten und dem gesamten Prüfverlauf.
  </p>


  <!-- Auswahl der Inbetriebnahme -->
  <mat-form-field appearance="outline" class="auswahl">
    <mat-label>Inbetriebnahme</mat-label>
    <mat-select [value]="inbetriebnahmeId" (selectionChange)="onInbetriebnahmeChange($event.value)">
      <mat-option *ngFor="let inb of inbetriebnahmen" [value]="inb.id">
        {{ inb.name }} ({{ inb.messstellenCount }} Messstellen)
      </mat-option>
    </mat-select>
  </mat-form-field>


  <!-- Auswahl der Messstelle -->
  <mat-form-field appearance="outline" class="auswahl">
    <mat-label>{{ kennzeichnungTitel }}</mat-label>
    <mat-select [(ngModel)]="messstelleId" panelClass="messstellen-select-panel"
      [disabled]="inbetriebnahmeId == null || ladeMessstellen || messstellen.length === 0">

      <!-- Anzeige, wenn eine Messstelle ausgewählt wurde -->
      <mat-select-trigger *ngIf="ausgewaehlteMessstelle as m">

        <span class="messstelle-trigger-kennzeichnung">
          {{ m.kennzeichnung || m.name }}
        </span>

        <span class="messstelle-trigger-langtext" *ngIf="m.langtext">
          · {{ m.langtext }}
        </span>

      </mat-select-trigger>


      <!-- Einträge im Dropdown -->
      <mat-option *ngFor="let m of messstellen" [value]="m.id" class="messstelle-option">

        <div class="messstelle-option-inhalt">

          <div class="messstelle-option-kopf">

            <!-- Prüfstatus -->
            <span class="messstelle-status" [class.status-offen]="m.pruefStatus === 'Offen'"
              [class.status-nicht-gestartet]="m.pruefStatus === 'Nicht gestartet'"
              [class.status-geprueft]="m.pruefStatus === 'Geprüft'">

              {{ m.pruefStatus }}

            </span>


            <!-- KKS / AKZ / Messkreisnummer / ... -->
            <span class="messstelle-kennzeichnung">
              {{ m.kennzeichnung || m.name }}
            </span>

          </div>


          <!-- Langtext -->
          <div class="messstelle-langtext" [class.messstelle-langtext-leer]="!m.langtext">

            {{ m.langtext || 'Kein Langtext vorhanden' }}

          </div>

        </div>

      </mat-option>

    </mat-select>
    <mat-hint *ngIf="inbetriebnahmeId == null">Bitte zuerst eine Inbetriebnahme wählen.</mat-hint>
    <mat-hint *ngIf="ladeMessstellen">Messstellen werden geladen …</mat-hint>
    <mat-hint *ngIf="!ladeMessstellen && inbetriebnahmeId != null && messstellen.length === 0 && !ladeFehler">
      Diese Inbetriebnahme enthält keine Messstellen.
    </mat-hint>
  </mat-form-field>

  <p class="fehler" *ngIf="ladeFehler">
    <mat-icon>error_outline</mat-icon>
    {{ ladeFehler }}
  </p>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="abbrechen()">Abbrechen</button>
  <button mat-raised-button color="primary" type="button" [disabled]="!istGueltig" (click)="exportieren()">
    <mat-icon>picture_as_pdf</mat-icon>
    PDF erstellen
  </button>
</mat-dialog-actions>
